import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  notifications: 'notifications',
  undeliveredNotification: 'notifications/undelivered-notification',
};

const NotificationsService = {
  getAllNotificationsById: (id: string) => RequestService.get(`${endpoints.notifications}/${id}`),
  getAllNotificationsByUserId: (id: string) => RequestService.get(`${endpoints.notifications}/user/${id}`),
  markAsReadNotification: (id: string | number) => RequestService.patch(`${endpoints.notifications}/${id}/read`),
  markAllAsReadNotification: (id: string | number) => RequestService.patch(`${endpoints.notifications}/user/${id}/read-all`),
  getUndeliveredNotification: () => RequestService.get(endpoints.undeliveredNotification, { showLoader: false }),
};

export default NotificationsService;
